export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || "http://192.168.10.210:8000";

let memToken: string | null = null;

export function setToken(t: string | null) {
  memToken = t;
  if (typeof window !== "undefined") {
    if (t) localStorage.setItem("finance_token", t);
    else localStorage.removeItem("finance_token");
  }
}

export function getToken(): string | null {
  if (memToken) return memToken;
  if (typeof window !== "undefined") {
    memToken = localStorage.getItem("finance_token");
  }
  return memToken;
}

export async function apiFetch<T = unknown>(
  path: string,
  opts: RequestInit = {}
): Promise<T> {
  const t = getToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(opts.headers as Record<string, string>),
    ...(t ? { Authorization: `Bearer ${t}` } : {}),
  };
  const res = await fetch(`${API_URL}${path}`, { ...opts, headers });
  if (res.status === 401) {
    setToken(null);
    if (typeof window !== "undefined" && window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    throw new Error("Session expirée");
  }
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`HTTP ${res.status}: ${body}`);
  }
  return res.status === 204 ? (null as T) : ((await res.json()) as T);
}

/** Erreur de connexion portant le code backend (totp_required, invalid_totp, …). */
export class LoginError extends Error {
  code: string;
  constructor(code: string) { super(code); this.code = code; this.name = "LoginError"; }
}

export async function login(email: string, password: string, totpCode?: string): Promise<string> {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, ...(totpCode ? { totp_code: totpCode } : {}) }),
  });
  if (!res.ok) {
    let code = `http_${res.status}`;
    try { const b = await res.json(); if (b?.detail) code = String(b.detail); } catch { /* ignore */ }
    throw new LoginError(code);
  }
  const data = (await res.json()) as { token: string };
  return data.token;
}

export async function apiUpload<T = unknown>(path: string, form: FormData): Promise<T> {
  const t = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    method: "POST",
    headers: t ? { Authorization: `Bearer ${t}` } : {},
    body: form,
  });
  if (res.status === 401) {
    setToken(null);
    if (typeof window !== "undefined" && window.location.pathname !== "/login") window.location.href = "/login";
    throw new Error("Session expirée");
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${await res.text()}`);
  return res.json();
}

export async function apiBlob(path: string): Promise<Blob> {
  const t = getToken();
  const res = await fetch(`${API_URL}${path}`, { headers: t ? { Authorization: `Bearer ${t}` } : {} });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.blob();
}
